import { useAssetUpload } from '@/hooks/useAssetUpload';
import { createContext } from 'react';

export const AssetUploadContext = createContext<ReturnType<typeof useAssetUpload> | undefined>(undefined);
